import { Euler, Material, Matrix4, Mesh, PlaneGeometry, Vector3 } from 'three';
import { SimpleTextValueVO, TextValueVO } from '@shared/vo/meta-element.vo';
import { TextureUtils } from '@3d-scene/model3d/util/texture-utils';
import { MathUtils } from '@3d-scene/common/util/math-utils';
import { ILayerElement } from '@3d-scene/layer/elements/i-layer-element';
import { ConfiguratorParameters } from '../../configurator-parameters/configurator-parameters';

export class LabelElement extends Mesh implements ILayerElement {
  public static readonly DEFAULT_FONT_SIZE: number = 12;
  public static readonly DEFAULT_ROTATION: Vector3 = new Vector3(90, 180, 0);
  public static readonly DEFAULT_LABEL_LENGTH: number = 250;
  public static readonly DEFAULT_LABEL_WIDTH: number = 50;

  public layerElementType: string = 'ILayerElement';

  constructor( text: TextValueVO, fontSize: number = LabelElement.DEFAULT_FONT_SIZE,
    initialRotation: Vector3 = LabelElement.DEFAULT_ROTATION,
    labelLength: number = LabelElement.DEFAULT_LABEL_LENGTH,
    labelWidth: number = LabelElement.DEFAULT_LABEL_WIDTH,
    fontScale: number = ConfiguratorParameters.labeling.defaultFontScale) {
    super(new PlaneGeometry(labelLength < 1 ? 1 : labelLength, labelWidth < 1 ? 1 : labelWidth));
    this.applyMatrix4(new Matrix4().makeRotationFromEuler(new Euler(
      MathUtils.toRadians(initialRotation.x),
      MathUtils.toRadians(initialRotation.y),
      MathUtils.toRadians(initialRotation.z))));
    this.createMaterial(text as SimpleTextValueVO, fontSize, fontScale);
  }

  private createMaterial(text: SimpleTextValueVO, fontSize: number, fontScale: number): void {
    TextureUtils.createTexture(this, text, true, 0xffffff, false, fontSize * fontScale);
    (this.material as Material).depthTest = false; // to fix overlapping of one label with another
  }
}
